import { Col, Row } from 'reactstrap';
import { DateFilter } from './DateFilter';
import { TeacherInfo } from './TeacherInfo';
import { useState } from 'react';
import { useTexts } from '../hooks/useTexts';
import { useAttendancesTableFetch } from './AttendancesTableLoader';
import DownloadReport from './DownloadReport';
import { useGetDateFilterOptions } from '../hooks/useGetDateFilterOptions';

type Props = {
  teacherId: number;
  teacherName: string;
  teacherIdentification: string;
};

export function AttendancesDateFilterAndTeacherInfo({
  teacherId,
  teacherIdentification,
  teacherName,
}: Props) {
  const texts = useTexts();
  const { query } = useAttendancesTableFetch();
  const dateFilterOptions = useGetDateFilterOptions();
  const [selectDate, setSelectdate] = useState(dateFilterOptions[0].value);
  return (
    <>
      <Row className="d-flex space-between mb-4">
        <Col xs={12} md={6} className="mb-4 mb-md-0">
          <div className="fs-16">{texts.viewInfo}</div>
        </Col>
        <Col
          xs={12}
          md={6}
          className=" d-flex justify-content-center justify-content-md-end"
        >
          <TeacherInfo
            teacherName={teacherName}
            teacherIdentification={teacherIdentification}
          />
        </Col>
      </Row>
      <Row xs={12} className="d-flex justify-content-between mb-4 gap-4">
        <Col xs={12} lg={3}>
          <DateFilter selectDate={selectDate} setSelectDate={setSelectdate} />
        </Col>
        <Col
          xs={12}
          lg={5}
          xl={3}
          className="d-flex align-items-center justify-content-end"
        >
          <DownloadReport
            teacherId={teacherId}
            query={query}
            dateFilterOptions={dateFilterOptions}
          />
        </Col>
      </Row>
    </>
  );
}
